import { connect } from 'react-redux';

import { addToComparison, removeFromComparison, clearComparison, toggleDrawerCollapsed } from './ComparisonActions';

const mapStateToProps = state => ({
  selectedShingles: state.comparison?.selectedShingles || [],
  isDrawerCollapsed: state.comparison?.isDrawerCollapsed ?? true,
  comparisonCount: state.comparison?.selectedShingles?.length || 0,
  canAddMore: (state.comparison?.selectedShingles?.length || 0) < 3,
  canCompare: (state.comparison?.selectedShingles?.length || 0) >= 2,
});

const mapDispatchToProps = {
  addToComparison,
  removeFromComparison,
  clearComparison,
  toggleDrawerCollapsed,
};

export const connectComparison = component => connect(mapStateToProps, mapDispatchToProps)(component);
